module.exports = __webpack_public_path__ + "img/y-238.8bd1f0d9.png";